import { ProvidersStatusTooltip } from './providers-status-tooltip'

export default ProvidersStatusTooltip
